import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import getAddGameCallbackParams from '@helpers/getAddGameCallbackParams';
import removeQueryParams from '@helpers/removeQueryParams';
import { ACTION_SHOW_GAME_MODAL } from '@hooks/useAddGameWebView';
/**
 * @returns A function that will remove the add game params.
 */
const useRemoveAddGameParams = () => {
    const location = useLocation();
    const addGameStatus = getAddGameCallbackParams(location.search);
    const history = useHistory();
    const hasMobileAddGameAction = new URLSearchParams(location.search).get('webViewAction') === ACTION_SHOW_GAME_MODAL;
    const removeAddGameParams = useCallback(() => {
        if (history && (addGameStatus || hasMobileAddGameAction)) {
            const { search, hash } = removeQueryParams(['added_game', 'add_game_error', 'add_game_region_code', 'add_game_service_key', 'webViewAction'], location.search);
            history.replace({ search, hash });
        }
    }, [history, addGameStatus, hasMobileAddGameAction, location.search]);
    return removeAddGameParams;
};
export default useRemoveAddGameParams;
